import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_APPROVEOTP_FULFILLED = "FETCH_APPROVEOTP_FULFILLED";
export const FETCH_APPROVEOTP_REJECTED = "FETCH_APPROVEOTP_REJECTED";
export const FETCH_APPROVEOTP_PENDING = "FETCH_APPROVEOTP_PENDING";
export const RESET_APPROVEOTP = "RESET_APPROVEOTP";


export function approveOtp(Agreement, OtpCode) {
  const token = localStorage.getItem("accessToken")
  return dispatch => {
    dispatch({
      type: "FETCH_APPROVEOTP",
      payload: axios({
        method: "post",
        url: `${API_BASE}/api/v3/second-opinion/approve-second-opinion-agreement`,
        data: { Agreement, OtpCode },
        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetApproveOtp() {
  return (dispatch) => {
    dispatch({
      type: "RESET_APPROVEOTP",
    });
  };
}